import i18n from 'src/utils/translate';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Button from 'src/components/buttons/button';
import signupContext from 'src/constants/signupContext';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { useModalTrigger } from 'src/utils/hooks';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import ModalType from 'src/constants/modalTypes';
import { State } from 'src/types';

const ContactAdminsButton = styled(Button)`
  margin-bottom: 10px;
`;

export default function ContactAdmins({ admins, page }: {admins: any[], page: string}) {
  const triggerContactAdminsModal = useModalTrigger(ModalType.CONTACT_ADMINS, { admins });
  const { currentUser, currentCommunity } = useSelector(({context}: State) => context);
  const dispatch = useDispatch();

  const handleClick = () => {
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickType: 'community-contact',
      clickMetadata: { section: page },
    });
    if (!currentUser) {
      dispatch(showSignupModal({
        section: signupContext.section.COMMUNITY_ABOUT,
        element: signupContext.element.CONTACT_US,
      }, currentCommunity));
    } else {
      triggerContactAdminsModal();
    }
  };

  return (
    <ContactAdminsButton onClick={handleClick}>{i18n.t('Contact us')}</ContactAdminsButton>
  );
}
